import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const IntroductionSection = ({ heading, accentIndex = 0 }) => (
  <GuidePanel sectionId="introduction" heading={heading} accentIndex={accentIndex}>
    <GuideCallout variant="amber">
      Mental clarity is often misunderstood. Many people believe it means having a calm mind, thinking
      positively, or never feeling stressed. In reality, mental clarity is something much more practical.
    </GuideCallout>
    <GuideLead>
      Mental clarity is the ability to distinguish facts from assumptions, respond instead of react, and make
      thoughtful decisions even when emotions, uncertainty, or pressure are present.
    </GuideLead>
    <GuideSectionLabel>Who this guide is for</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="clarity" title="Professionals" description="Under pressure and seeking clearer thinking" />
      <GuideCard iconKey="leader" title="Leaders" description="Making thoughtful decisions under uncertainty" />
      <GuideCard iconKey="energy" title="Entrepreneurs" description="Navigating uncertainty with structured thinking" />
      <GuideCard iconKey="communication" title="Introverts" description="Translating deep thinking into clear communication" />
    </GuideCardGrid>
    <GuideCallout>
      This guide explores what mental clarity is, why it matters, how it is affected by stress, and how to
      develop it as a lifelong capability.
    </GuideCallout>
  </GuidePanel>
);

export default IntroductionSection;
